namespace Matrix.Administration {
    export interface RoleForm {
        RoleName: Serenity.StringEditor;
        DashboardCode: Serenity.ServiceLookupEditor;
        Groups: FormatLookupEditor;
        PermissionSets: FormatLookupEditor;
        GrantedPermissions: PermissionCheckEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class RoleForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.Role';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!RoleForm.init)  {
                RoleForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.ServiceLookupEditor;
                var w2 = FormatLookupEditor;
                var w3 = PermissionCheckEditor;
                var w4 = StaticTextBlock;
                var w5 = ReadOnlyDateTime;

                Q.initFormType(RoleForm, [
                    'RoleName', w0,
                    'DashboardCode', w1,
                    'Groups', w2,
                    'PermissionSets', w2,
                    'GrantedPermissions', w3,
                    'CreatedBy', w4,
                    'CreatedWhen', w5,
                    'UpdatedBy', w4,
                    'UpdatedWhen', w5,
                    'Version', w4
                ]);
            }
        }
    }
}
